import { useRef, useEffect, useState } from "react";
import {useNavigate} from "react-router-dom";

export const CategoryComponent = ({categories}) => {
    const scrollRef = useRef(null);
    const scrollInterval = useRef(null);
    const [isAtEnd, setIsAtEnd] = useState(false);

    const startScrolling = () => {
        stopScrolling();
        scrollInterval.current = setInterval(() => {
            if (scrollRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
                if (scrollLeft + clientWidth >= scrollWidth) {
                    setIsAtEnd(true);
                    stopScrolling();
                } else {
                    setIsAtEnd(false);
                    scrollRef.current.scrollBy({ left: 1, behavior: "smooth" });
                }
            }
        }, 10);
    };

    const stopScrolling = () => {
        if (scrollInterval.current) {
            clearInterval(scrollInterval.current);
        }
    };

    useEffect(() => {
        startScrolling();
        return () => stopScrolling();
    }, []);

    return (
        <div className="w-full pb-4 md:pb-8 lg:pb-16 pt-0">
            {/* Header */}
            <div className={"w-full flex  main-bg-clip-bg pt-0 pb-0 md:pt-8 md:pb-8"}>
                <div className={"w-full  mx-auto"} style={{maxWidth:"1500px"}}>
                    <div className={"w-full md:w-10/12  lg:w-6/12 pt-10 pb-20 mx-auto"}>
                        <div className={"text-center block md:flex items-center"}>
                            <div className={"md:border-r ms-auto md:pe-6 border-gray-700"}>
                                <h1 className={"text-white text-2xl md:text-3x font-semibold "}>
                                    PRODUK LAINNYA</h1>
                            </div>
                            <div className={" me-auto md:ms-0 md:ps-6 ms-auto md:me-auto"}>
                                <h4 className={"text-red-600 mx-auto font-semibold text-md"}>K A T A L O G M E S I N</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"mx-auto"}  style={{maxWidth:"1500px"}}>
                {categories?.length === 0 ? (
                    <div className="relative xl:w-full w-11/12  mx-auto overflow-x-auto scroll-container">
                        <ul className={"w-full gap-3 md:flex-nowrap flex-wrap flex  overflow-x-auto scroll-container "}>
                            <li key={0} className={"w-full md:w-3/12"}>
                                <div className={""}>
                                    <EmptyCategoryCardComponent index={0} />
                                </div>
                            </li>
                            <li key={1} className={"w-full md:w-3/12"}>
                                <div className={""}>
                                    <EmptyCategoryCardComponent index={0} />
                                </div>
                            </li>
                            <li key={2} className={"w-full md:w-3/12"}>
                                <div className={""}>
                                    <EmptyCategoryCardComponent index={0} />
                                </div>
                            </li>
                            <li key={3} className={"w-full md:w-3/12"}>
                                <div className={""}>
                                    <EmptyCategoryCardComponent index={0} />
                                </div>
                            </li>
                        </ul>
                    </div>
                ): (
                    <div className={""} style={{maxWidth:"1500px"}}>
                        <div
                            className="relative xl:w-full w-11/12  mx-auto overflow-x-auto scroll-container"
                            ref={scrollRef}
                            onMouseEnter={stopScrolling}
                            onMouseLeave={() => !isAtEnd && startScrolling()}
                        >
                            <ul className="flex gap-4 px-6 py-4">
                                {categories.map((item, index) => {
                                    return(
                                        <li key={index} className="w-80 flex-shrink-0">
                                            <CategoryCardComponent id={item?.id} name={item?.name} img={item?.image} slug={item?.slug} image={item?.image}/>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export const CategoryCardComponent = ({id, img, name, slug, image}) => {
    const navigate = useNavigate();
    const handleKeyPress = (event) => {
        if (slug === "converyor-checkweigher-16") {
            window.location.href = "https://checkweigher.co.id/catalog";
        } else if (slug === "metal_detector") {
            window.location.href = "https://checkweigher.co.id/catalog";
        }
        // Jika ada tindakan default, tambahkan di sini
    };


    return (
        <div className="w-full rounded-lg">
            <div className="w-full hover:-translate-y-2  transition-transform duration-500 ease-in-out relative h-80 overflow-hidden group">
                <img
                    src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${img}`}
                    alt="Category"
                    className="w-full h-full object-contain rounded-md"
                />
                <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-blue-950 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                <div className="absolute -bottom-24 md:-bottom-24 left-4 md:left-4 w-11/12 mx-auto h-full flex items-center justify-left">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                        <div className={"mb-3 md:mb-4"}>
                            <h1 className="text-white font-medium text-xl md:text-md">{name}</h1>
                        </div>
                        <div>
                            <button
                                onClick={handleKeyPress}
                                className={"bg-main py-3 px-4 rounded-xs text-white "}>
                                <div className={"flex gap-2"}>
                                    <div className={""}>
                                        <p className={"text-xs font-medium "}>LIHAT CATALOG</p>
                                    </div>
                                    <div className={"h-4 my-auto"}>
                                        <img className={"h-full"} src={"assets/icon/icon-arrow.svg"} />
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export const EmptyCategoryCardComponent = ({}) => {

    return (
        <div className="w-full rounded-lg">
            <div className="w-full hover:-translate-y-2  transition-transform duration-500 ease-in-out relative h-80 overflow-hidden group">
                <div
                    className="w-full h-full bg-gray-200 animate-pulse object-contain rounded-md">
                </div>
                <div className="absolute bottom-0 left-0 w-full h-full bg-gradient-to-t from-blue-950 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                <div className="absolute -bottom-24 md:-bottom-24 left-4 md:left-4 w-11/12 mx-auto h-full flex items-center justify-left">
                    <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                        <div className={"mb-3 md:mb-4"}>
                            <h4 className="text-white w-10/12 h-4 font-medium bg-gray-400 rounded-lg animate-pulse text-xl md:text-md"></h4>
                        </div>
                        <div>
                            <button
                                className={"bg-main py-3 px-4 rounded-xs text-white "}>
                                <div className={"flex gap-2"}>
                                    <div className={""}>
                                        <p className={"text-xs font-medium "}>LIHAT CATALOG</p>
                                    </div>
                                    <div className={"h-4 my-auto"}>
                                        <img className={"h-full"} src={"assets/icon/icon-arrow.svg"} />
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
